/* eslint-disable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

const calculateHeight = (el) => {
  // Source adapted from: http://youmightnotneedjquery.com/#outer_height_with_margin
  let height = el.offsetHeight;
  const { marginTop, marginBottom } = getComputedStyle(el);

  height += parseInt(marginTop, 10) + parseInt(marginBottom, 10);
  return height;
};

// Source adapted from: http://stackoverflow.com/a/16324762
const makeHandler = (el) => (event) => {
  const { scrollTop, scrollHeight } = el;
  const { type, detail, wheelDelta } = event;
  const height = calculateHeight(el);
  const delta = type === 'DOMMouseScroll' ? detail * -40 : wheelDelta;
  const up = delta > 0;

  const prevent = () => {
    event.stopPropagation();
    event.preventDefault();
    event.returnValue = false;

    return false;
  };

  if (!up && -delta > scrollHeight - height - scrollTop) {
    el.scrollTop = scrollHeight;
    return prevent();
  } else if (up && delta > scrollTop) {
    el.scrollTop = 0;
    return prevent();
  }
};

/**
 * @deprecated - This has been imported from https://github.com/markdalgleish/isolated-scroll/blob/master/src/index.js.
 */

const isolatedScroll = (el) => {
  const handler = makeHandler(el);

  const addEvent = (el.addEventListener || el.attachEvent).bind(el);
  const removeEvent = (el.removeEventListener || el.detachEvent).bind(el);

  addEvent('mousewheel', handler);
  addEvent('DOMMouseScroll', handler);

  return () => {
    removeEvent('mousewheel', handler);
    removeEvent('DOMMouseScroll', handler);
  };
};

const unbindHandlersKey = '__unbind_handlers__';

/**
 * @deprecated - This has been imported from https://github.com/markdalgleish/react-isolated-scroll/blob/master/src/index.js.
 */

export default class IsolatedScroll extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  };

  constructor(props) {
    super(props);

    this.storeComponentReference = this.storeComponentReference.bind(this);
  }

  componentDidMount() {
    this[unbindHandlersKey] = isolatedScroll(this.component);
  }

  componentWillUnmount() {
    this[unbindHandlersKey]();
  }

  storeComponentReference(component) {
    if (component !== null) {
      this.component = component;
    }
  }

  render() {
    const { children } = this.props;

    return (
      <div ref={this.storeComponentReference} {...this.props}>
        {children}
      </div>
    );
  }
}
